import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { Observable, Subject } from 'rxjs';

import { PlanPreventionService } from '../../services/plan-prevention.service';
import { applicationConstants } from '../../../../app.constants';
import { PlanPreventionEntity } from '../../entities/plan-prevention.entity';

@Component({
	selector: 'pdp-generation',
	templateUrl: 'pdp-generation.html',
	styleUrls: ['pdp-generation.css'],
})
export class PdpGenerationComponent {
	// Gestion globale de la fenetre
	displaySubject = new Subject<boolean>();
	pdpId: number = -1;
	valideurSignatairesApplicable: boolean = false;

	addBlankLinesTravaux: boolean = false;
	addBlankLinesAnalyseGlobale: boolean = false;
	addBlankLinesValidation: boolean = false;
	addBlankLinesEmargement: boolean = false;
	nbLinesEmargement: number = 10;

	lang: string = '';
	annexes: NgxFileDropEntry[] = [];
	formData: FormData = new FormData();
	
	constructor( @Inject(PlanPreventionService) private planPreventionService: PlanPreventionService ) {
	}

	@Input() id = 'pdpGenerationDialog';
	
	// Liaison de l'observable servant a commander l'affichage du composant
	@Input() set generationCommands(obs: Observable<PlanPreventionEntity>) {
		obs.subscribe(
			// lors de la reception d'une demande d'affichage du popup d egeneration
			(pdp: PlanPreventionEntity) => {
				console.log('demande affichage popup generation pour le PDP: ', pdp.numeroPdp);
		     	this.pdpId = pdp.id;
				this.valideurSignatairesApplicable = pdp.versionTechnique >= applicationConstants.versionInWhichValideursCanSignPdps && pdp.typePdp === 0;
		     	this.displaySubject.next(true);
			}
	 	);
	}

	// Evenements de validation de l'operation en cours (s'il y en a)
	@Output() decisionIssued = new EventEmitter<boolean>();
	
	reinitForm() {
		this.lang = '';
		this.pdpId = -1;
		this.valideurSignatairesApplicable = false;
		this.annexes = [];
		this.formData = new FormData();
		this.addBlankLinesTravaux = false;
		this.addBlankLinesAnalyseGlobale = false;
		this.addBlankLinesValidation = false;
		this.addBlankLinesEmargement = false;
		this.nbLinesEmargement = 10;
		this.displaySubject.next(false);
	}

	onCloseRequested() {
		this.reinitForm();
		this.decisionIssued.emit(false);
	}
	
	generatePdf() {
		console.log('appel au serveur pour générer le pdf du PDP id: ', this.pdpId);
		const fileName: string = 'plan-de-prevention-' + this.pdpId.toString() + '-' + this.lang + '.pdf';
		this.formData.append('lang', this.lang);
		this.formData.append('idPdp', this.pdpId.toString());
		if (this.addBlankLinesTravaux) {
			this.formData.append('addTravaux', this.addBlankLinesTravaux.toString());
		}
		if (this.addBlankLinesAnalyseGlobale) {
			this.formData.append('addAnalyse', this.addBlankLinesAnalyseGlobale.toString());
		}
		if (this.addBlankLinesValidation) {
			this.formData.append('addValidation', this.addBlankLinesValidation.toString());
		}
		if (this.addBlankLinesEmargement) {
			this.formData.append('addEmargement', this.nbLinesEmargement.toString());
		}
		
		this.planPreventionService.generatePdf(this.formData).subscribe(
			(blob: Blob) => {
				const objectUrl: string = URL.createObjectURL(blob);
				const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
				a.href = objectUrl;
				a.download = fileName;
				document.body.appendChild(a);
				a.click();        
				
				document.body.removeChild(a);
				URL.revokeObjectURL(objectUrl);
  			},
			(err: any) => {
    			console.log('Could not upload the file, error: ', err);
			}
		);
		this.reinitForm();
		this.decisionIssued.emit(true);
	}
	
	dropped(files: NgxFileDropEntry[]) {
    	for (const droppedFile of files) {
      		// Is it a file?
 			if (droppedFile.fileEntry.isFile) {
				const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
				fileEntry.file((file: File) => {
					console.log(droppedFile.relativePath, file);
					if (file.type === applicationConstants.pdpAutorizedAnnexeType && !this.alreadyAdded(droppedFile)) {
						this.annexes.push(droppedFile);
						const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
						let i: number = 1;
						fileEntry.file((file: File) => {
							const fileName = 'annexe-' + i++ + '.pdf';
							this.formData.append('annexes', file, fileName);
						});
					} else {
						console.log('dossier non PDF ignoré par l\'import: ', file);
					}
        		});
			} else {
				// les dossiers sont ignorés par l'import
				console.log('dossier ignoré par l\'import: ', droppedFile);
      		}
		}
	}
	
	private alreadyAdded(fileEntry: NgxFileDropEntry) {
		return this.annexes.some( e => e.relativePath === fileEntry.relativePath );
	}
	
	public removeFile(item: NgxFileDropEntry) {
		console.log('demande suppression fichier: ', item);
		this.annexes = this.annexes.filter( file => file.relativePath !== item.relativePath );
	}

	public fileOver(event: Event){
    	console.log(event);
	}

	public fileLeave(event: Event){
		console.log(event);
	}
}